import { render } from "./nahalTavor.vue?vue&type=template&id=20aa15c4&scoped=true"
import script from "./nahalTavor.vue?vue&type=script&lang=js"
export * from "./nahalTavor.vue?vue&type=script&lang=js"

import "./nahalTavor.vue?vue&type=style&index=0&id=20aa15c4&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20aa15c4"]])

export default __exports__